declare const I18n;

import React from "react";
import CheckboxInput from "./inputs/CheckboxInput";

type Props = {
  block: any;
  data: Record<string, any>;
  customStyle?: any;
  onChange: (
    key: string,
    value: any,
    options?: {
      groupKey?: string;
    }
  ) => void;
};

const CheckboxGroup: React.FC<Props> = ({ block, data, onChange, customStyle}) => {
  const sectionGroup = block.inputGroup;

  const field = block.props.fields?.[0];
  if (!field || !Array.isArray(field.options)) return null;

  const fieldKey = field.key;

  const currentValues: string[] = Array.isArray(
    sectionGroup ? data?.[sectionGroup]?.[fieldKey] : data?.[fieldKey]
  )
    ? sectionGroup
      ? data[sectionGroup][fieldKey]
      : data[fieldKey]
    : [];

  const toggleValue = (value: string, checked: boolean) => {
    const updatedValues = checked
      ? Array.from(new Set([...currentValues, value]))
      : currentValues.filter((v) => v !== value);

    if (sectionGroup) {
      onChange(fieldKey, updatedValues, { groupKey: sectionGroup });
    } else {
      onChange(fieldKey, updatedValues);
    }
  };

  const fieldLabel = field.labelKey
    ? I18n.t(field.labelKey)
    : field.label || "";

  const isSingle = field.options.length === 1;

  return (
    <div className="choice-group">
      {fieldLabel && (
        <div className="choice-group__label">{fieldLabel}</div>
      )}
      <div className={`choice-grid ${isSingle ? 'choice-grid--single' : 'choice-grid--multi'}`}>
        {field.options.map((opt: any) => {
          const optionLabel = opt.labelKey
            ? I18n.t(opt.labelKey)
            : opt.label || "";

          return (
            <div key={opt.value} className="choice-grid__item">
              <CheckboxInput
                label={optionLabel}
                name={fieldKey}
                value={opt.value}
                checked={currentValues.includes(opt.value)}
                onChange={(checked) => toggleValue(opt.value, checked)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CheckboxGroup;
